import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../utils/queries'

import HomeDir1 from './homedir1';
import HomeDir2 from './homedir2';

import DirDpto1 from './direcc/dirdpto1';
import DirDpto2 from './direcc/dirdpto2';
import AddDpto1 from './direcc/adddpto1';
import AddDpto2 from './direcc/adddpto2';
import VerDpto1 from './direcc/verdpto1';
import VerDpto2 from './direcc/verdpto2';

import DirCiu1 from './direcc/dirciu1';
import DirCiu2 from './direcc/dirciu2';
import AddCiu1 from './direcc/addciu1';
import AddCiu2 from './direcc/addciu2';
import VerCiu1 from './direcc/verciu1';
import VerCiu2 from './direcc/verciu2';

import DirZon1 from './direcc/dirzon1';
import DirZon2 from './direcc/dirzon2';
import AddZon1 from './direcc/addzon1';
import AddZon2 from './direcc/addzon2';
import VerZon1 from './direcc/verzon1';
import VerZon2 from './direcc/verzon2';

import DirBarr1 from './direcc/dirbarr1';
import DirBarr2 from './direcc/dirbarr2';
import AddBarr1 from './direcc/addbarr1';
import AddBarr2 from './direcc/addbarr2';
import VerBarr1 from './direcc/verbarr1';
import VerBarr2 from './direcc/verbarr2';

import DirTum1 from './direcc/dirtum1';
import DirTum2 from './direcc/dirtum2';
import AddTum1 from './direcc/addtum1';
import AddTum2 from './direcc/addtum2';
import VerTum1 from './direcc/vertum1';
import VerTum2 from './direcc/vertum2';

import DirUm1 from './direcc/dirum1';
import DirUm2 from './direcc/dirum2';
import AddUm1 from './direcc/addum1';
import AddUm2 from './direcc/addum2';
import VerUm1 from './direcc/verum1';
import VerUm2 from './direcc/verum2';

import DirTiUn1 from './direcc/dirtiun1';
import DirTiUn2 from './direcc/dirtiun2';
import AddTiUn1 from './direcc/addtiun1';
import AddTiUn2 from './direcc/addtiun2';
import VerTiUn1 from './direcc/vertiun1';
import VerTiUn2 from './direcc/vertiun2';

import DirTiVi1 from './direcc/dirtivi1';
import DirTiVi2 from './direcc/dirtivi2';
import AddTiVi1 from './direcc/addtivi1';
import AddTiVi2 from './direcc/addtivi2';
import VerTiVi1 from './direcc/vertivi1';
import VerTiVi2 from './direcc/vertivi2';

import DirEstr1 from './direcc/direstr1';
import DirEstr2 from './direcc/direstr2';
import AddEstr1 from './direcc/addestr1';
import AddEstr2 from './direcc/addestr2';
import VerEstr1 from './direcc/verestr1';
import VerEstr2 from './direcc/verestr2';

import DirNodo1 from './direcc/dirnodo1';
import DirNodo2 from './direcc/dirnodo2';
import AddNodo1 from './direcc/addnodo1';
import AddNodo2 from './direcc/addnodo2';
import VerNodo1 from './direcc/vernodo1';
import VerNodo2 from './direcc/vernodo2';

//ACTUALIZAR BD
async function crudBD(operacionCRUD, args, i) {
// console.log("CRUD")
  if(args.ctrlCampo === 'CRUD'){
// console.log(i)
// console.log(args)
    const {data} = await operacionCRUD({
      variables: args
    });
//Se utiliza para traer el _id del documento creado
    if(args.ctrl_id === 'SI_ID'){
      if(Object.values(data)[0]._id){
        return Object.values(data)[0]._id
      }else{
        return 0
      }
    }
  }else{
    if(args.ctrlCampo === "MANY"){
      // console.log("MANY")
      // console.log(args)
      await operacionCRUD({
        variables: args
      });
      // console.log("11")
    }
  }
}

//ENVIO PARA ACTUALIZAR BD
async function updColecc(crudColecc, argsCrud, totDocCRUD) {
// console.log(argsCrud)
// console.log(totDocCRUD)
  let codigo = 0
  // console.log(argsCrud)
  if(argsCrud[0].ctrl_id === 'SI_ID'){
    codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
  }else{
    await crudBD(crudColecc[0], argsCrud[0], 0)
  }
  if(codigo!==0){
    for(let i=1; i<totDocCRUD; i++){
      argsCrud[i]._id = codigo
    }
  }
// console.log("inicio")
  for(let i=1; i<totDocCRUD; i++){
    await crudBD(crudColecc[i], argsCrud[i], i)
  }
console.log("final")
}

class HomeDir extends React.Component{
  state={
    showDir: true,

    showDpto: false,
    addDpto: false,
    verDpto: false,

    showCiu: false,
    addCiu: false,
    verCiu: false,

    showZon: false,
    addZon: false,
    verZon: false,

    showBarr: false,
    addBarr: false,
    verBarr: false,

    showTiUndMat: false,
    addTiUndMat: false,
    verTiUndMat: false,

    showUndMat: false,
    addUndMat: false,
    verUndMat: false,

    showTipoUnd: false,
    addTipoUnd: false,
    verTipoUnd: false,

    showTipoVia: false,
    addTipoVia: false,
    verTipoVia: false,

    showEstrato: false,
    addEstrato: false,
    verEstrato: false,

    showNodo: false,
    addNodo: false,
    verNodo: false,

    permiteUpdate: false,
    permiteDelete: false,

    argsAdd: {},
    errorAdd: [],

    idLista: {}
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  showDir = (ev) => {
    ev.preventDefault()
    this.props.allDirmayor.refetch()
    this.estadosFalse()
    this.setState({showDir: true})
  }

  showDpto = (ev) => {
    ev.preventDefault()
    this.props.allDirmayor.refetch()
    this.estadosFalse()
    this.setState({showDpto: true})
  }

  showCiu = (ev) => {
    ev.preventDefault()
    this.props.allDirmayor.refetch()
    this.estadosFalse()
    this.setState({showCiu: true})
  }

  showZon = (ev) => {
    ev.preventDefault()
    this.props.allDirmayor.refetch()
    this.estadosFalse()
    this.setState({showZon: true})
  }

  showBarr = (ev) => {
    ev.preventDefault()
    this.props.allDirmayor.refetch()
    this.estadosFalse()
    this.setState({showBarr: true})
  }

  showTiUndMat = (ev) => {
    ev.preventDefault()
    this.props.allTiUndMat.refetch()
    this.estadosFalse()
    this.setState({showTiUndMat: true})
  }

  showUndMat = (ev) => {
    ev.preventDefault()
    this.props.allUndMat.refetch()
    this.estadosFalse()
    this.setState({showUndMat: true})
  }

  showTipoUnd = (ev) => {
    ev.preventDefault()
    this.props.allTipoUnd.refetch()
    this.estadosFalse()
    this.setState({showTipoUnd: true})
  }

  showTipoVia = (ev) => {
    ev.preventDefault()
    this.props.allTipoVia.refetch()
    this.estadosFalse()
    this.setState({showTipoVia: true})
  }

  showEstrato = (ev) => {
    ev.preventDefault()
    this.props.allEstrato.refetch()
    this.estadosFalse()
    this.setState({showEstrato: true})
  }

  showNodo = (ev) => {
    ev.preventDefault()
    this.props.allNodo.refetch()
    this.estadosFalse()
    this.setState({showNodo: true})
  }
  
  addDpto = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addDpto: true})
  }

  addCiu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCiu: true})
  }

  addZon = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addZon: true})
  }

  addBarr = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addBarr: true})
  }

  addTiUndMat = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTiUndMat: true})
  }

  addUndMat = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addUndMat: true})
  }

  addTipoUnd = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipoUnd: true})
  }

  addTipoVia = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipoVia: true})
  }

  addEstrato = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addEstrato: true})
  }

  addNodo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addNodo: true})
  }

  handleChange = (ev, input)=>{
    // if (this.state.addDpto) {
      // console.log(input)
      const argsAdd = this.state.argsAdd
      argsAdd[ev.target.name] = ev.target.value
      // argsAdd[input.name] = input.value
      this.setState({argsAdd});
    // }
    // if (this.state.addCiu) {
    //   const argsAdd = this.state.argsAdd
    //   argsAdd[input.name] = input.value
    //   this.setState({argsAdd});
    // }
    // if (this.state.addZon) {
    //   const argsAdd = this.state.argsAdd
    //   argsAdd[input.name] = input.value
    //   this.setState({argsAdd});
    // }
    // if (this.state.addBarr) {
    //   const argsAdd = this.state.argsAdd
    //   argsAdd[input.name] = input.value
    //   this.setState({argsAdd});
    // }
  }

  handleDpto = async (ev, args)=>{
    if(!args.codigoDpto||!args.descrDpto||!args.codigoDptoDANE){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoDpto){
        argsAdd['codigoDpto'] = "";
        errors.push({path: 'codigoDpto', message: "Debe escribir el código"});
      }
      if(!args.descrDpto){
        argsAdd['descrDpto'] = "";
        errors.push({path: 'descrDpto', message: "Debe escribir la descripción"});
      }
      if(!args.codigoDptoDANE){
        argsAdd['codigoDptoDANE'] = "";
        errors.push({path: 'codigoDptoDANE', message: "Debe escribir el Código departamento DANE"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addDpto){
        const response = await this.props.createDpto({
          variables: args
        });
        const {errors, success} = response.data.createDpto;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoDpto = document.getElementById("codigoDpto");
          var descrDpto = document.getElementById("descrDpto");
          var codigoDptoDANE = document.getElementById("codigoDptoDANE");
          codigoDpto.value = ""
          descrDpto.value = ""
          codigoDptoDANE.value = ""
          // const errors = [];
          // this.setState({errorAdd: errors})
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allDirmayor.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          let argsUpd = {
            _id: args._id,
            descrDpto: args.descrDpto,
            codigoDptoDANE: args.codigoDptoDANE
          }
          const response = await this.props.editDpto({
            variables: argsUpd
          });
          const {errors, success} = response.data.editDpto;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allDirmayor.refetch()
            this.estadosFalse()
            this.setState({showDpto: true})

            // ACTUALIZA EN clientes, facturacions, recursos Y usuarios
            let updDoc = [], updDocMany = [], updDocMany1 = []

            let argsMatch = `'dirmayor.codigoDpto': '${args.codigoDpto}'`
            let argsSet = `'dirmayor.descrDpto': '${args.descrDpto}', 'dirmayor.codigoDptoDANE': '${args.codigoDptoDANE}'`
            let argsUpdCl1 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Cliente.updateMany'}
            // updDoc.push(argsUpdCl1)

            argsMatch = `'descrDpto': '${args.descrDptoAnt}'`
            argsSet = `'descrDpto': '${args.descrDpto}', 'codigoDptoDANE': '${args.codigoDptoDANE}'`
            let argsUpdCl2 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Facturacion.updateMany'}
            // updDoc.push(argsUpdCl2)

            argsMatch = `'codigoDpto': '${args.codigoDpto}'`
            argsSet = `'descrDpto': '${args.descrDpto}'`
            let argsUpdCl3 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Recurso.updateMany'}

            argsMatch = `'codigoDpto': '${args.codigoDpto}'`
            argsSet = `'descrDpto': '${args.descrDpto}'`
            let argsUpdCl4 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Usuario.updateMany'}

            updDoc.push(argsUpdCl1)
            updDoc.push(argsUpdCl2)
            updDoc.push(argsUpdCl3)
            updDoc.push(argsUpdCl4)

            // console.log(updDoc)

            updDoc.forEach((elemento, ii) => {
              // console.log(elemento)
              updDocMany.push(elemento)
              updDocMany1.push({docum: updDocMany})
              updDocMany = []
            })
            // updDocMany1.push({docum: updDocMany})

            let numDocCRUD = 0, totDocCRUD = 4, argsCrud = [], crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.updDocumMany)
            }
            // console.log(updDocMany1[0])
            argsCrud[numDocCRUD] = updDocMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            numDocCRUD += 1
            argsCrud[numDocCRUD] = updDocMany1[1]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            numDocCRUD += 1
            argsCrud[numDocCRUD] = updDocMany1[2]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            numDocCRUD += 1
            argsCrud[numDocCRUD] = updDocMany1[3]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            // console.log(argsCrud)
            await updColecc(crudColecc, argsCrud, totDocCRUD)
            // ACTUALIZA EN clientes, facturacions, recursos Y usuarios
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            codigoDpto: args.codigoDpto
          }
          const response = await this.props.deleteDpto({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteDpto;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allDirmayor.refetch()
            this.estadosFalse()
            this.setState({showDpto: true})
          }
        }
      }
    }
  }

  handleCiu = async (ev, args)=>{
    if(!args.codigoCiudad||!args.nombreCiudad||!args.codigoMunicipioDANE||!args.codigoPostalDANE||
      !args.descrDpto||args.descrDpto==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoCiudad){
        argsAdd['codigoCiudad'] = "";
        errors.push({path: 'codigoCiudad', message: "Debe escribir el código"});
      }
      if(!args.nombreCiudad){
        argsAdd['nombreCiudad'] = "";
        errors.push({path: 'nombreCiudad', message: "Debe escribir la descripción"});
      }
      if(!args.codigoMunicipioDANE){
        argsAdd['codigoMunicipioDANE'] = "";
        errors.push({path: 'codigoMunicipioDANE', message: "Debe escribir el Código municipio DANE"});
      }
      if(!args.codigoPostalDANE){
        argsAdd['codigoPostalDANE'] = "";
        errors.push({path: 'codigoPostalDANE', message: "Debe escribir el Código postal"});
      }
      if(!args.descrDpto||args.descrDpto==="Seleccionar..."){
        argsAdd['_id'] = "";
        argsAdd['descrDpto'] = "Seleccionar...";
        errors.push({path: 'Dpto', message: "Debe seleccionar el departamento"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addCiu){
        //Validar si el codigo o el nombre de la ciudad ya existe
        const errors = [];
        const elemento2 = this.props.allDirmayor.allDirmayor
        elemento2.forEach((elemento, _id) => {
          if(elemento.ciudades.length>0){
            elemento.ciudades.forEach((elemento1, i) => {
              if(args.codigoCiudad===elemento1.codigoCiudad){
                errors.push({path: 'codigoCiudad', message: "El código de la ciudad ya existe"});
              }
              if(args.nombreCiudad===elemento1.nombreCiudad){
                errors.push({path: 'nombreCiudad', message: "El nombre de la ciudad ya existe"});
              }
            })
          }
        })

        if(errors.length===0){
          const fechaHoy = new Date()
          const argsUpd = {
            "_id": args._id,
            "tipoAct": "CrearCiudad",
            "codigoCiudad": args.codigoCiudad,
            "nombreCiudad": args.nombreCiudad,
            "codigoMunicipioDANE": args.codigoMunicipioDANE,
            "codigoPostalDANE": args.codigoPostalDANE,
            "codigoCiudadInterno": args.codigoCiudadInterno,
            "codBarrasRdo": args.codBarrasRdo,
            "fechaCreateCiu": fechaHoy,
            "usuarioCreateCiu": sessionStorage.getItem('userLogin')
          }
          // console.log(argsUpd)
          const response = await this.props.editDptoUpdCiu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var codigoCiudad = document.getElementById("codigoCiudad");
            var nombreCiudad = document.getElementById("nombreCiudad");
            var codigoMunicipioDANE = document.getElementById("codigoMunicipioDANE");
            var codigoPostalDANE = document.getElementById("codigoPostalDANE");
            var codigoCiudadInterno = document.getElementById("codigoCiudadInterno");
            var codBarrasRdo = document.getElementById("codBarrasRdo");
            var dpto = document.getElementById("miLista");
            dpto.options.selectedIndex = 0
            codigoCiudad.value = ""
            nombreCiudad.value = ""
            codigoMunicipioDANE.value = ""
            codigoPostalDANE.value = ""
            codigoCiudadInterno.value = ""
            codBarrasRdo.value = ""
            // const errors = [];
            // this.setState({errorAdd: errors})
            this.setState({argsAdd: {}})
            this.setState({errorAdd: []})
            this.props.allDirmayor.refetch()
          }
        }else{
          this.setState({errorAdd: errors})
        }
      }else{
        if(this.state.permiteUpdate){
//Validar si el nombre de la ciudad ya existe
          const errors = [];
          const elemento2 = this.props.allDirmayor.allDirmayor
          elemento2.forEach((elemento, _id) => {
            if(elemento.ciudades.length>0){
              elemento.ciudades.forEach((elemento1, i) => {
                if(args.nombreCiudad===elemento1.nombreCiudad && args.codigoCiudad!==elemento1.codigoCiudad){
                  errors.push({path: 'nombreCiudad', message: "El nombre de la ciudad ya existe"});
                }
              })
            }
          })
//
          if(errors.length===0){
            const argsUpd = {
              "_id": args._id,
              "tipoAct": "EditarCiudad",
              "codigoCiudad": args.codigoCiudad,
              "nombreCiudad": args.nombreCiudad,
              "codigoMunicipioDANE": args.codigoMunicipioDANE,
              "codigoPostalDANE": args.codigoPostalDANE,
              "codigoCiudadInterno": args.codigoCiudadInterno,
              "codBarrasRdo": args.codBarrasRdo,
            }
            // console.log(argsUpd)
            const response = await this.props.editDptoUpdCiu({
              variables: argsUpd
            });
            const {errors, success} = response.data.editDptoUpdCiu;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              this.props.allDirmayor.refetch()
              this.estadosFalse()
              this.setState({showCiu: true})

              // ACTUALIZA EN clientes, facturacions, recursos Y usuarios
              let updDoc = [], updDocMany = [], updDocMany1 = []

              let argsMatch = `'dirmayor.ciudades.codigoCiudad': '${args.codigoCiudad}'`
              let argsSet = `'dirmayor.ciudades.nombreCiudad': '${args.nombreCiudad}', 'dirmayor.ciudades.codigoMunicipioDANE': '${args.codigoMunicipioDANE}', 'dirmayor.ciudades.codigoPostalDANE': '${args.codigoPostalDANE}', 'dirmayor.ciudades.codigoCiudadInterno': '${args.codigoCiudadInterno}', 'dirmayor.ciudades.codBarrasRdo': '${args.codBarrasRdo}'`
              let argsUpdCl1 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Cliente.updateMany'}
              // updDoc.push(argsUpdCl1)

              argsMatch = `'nombreCiudad': '${args.nombreCiudadAnt}'`
              argsSet = `'nombreCiudad': '${args.nombreCiudad}', 'codigoMunicipioDANE': '${args.codigoMunicipioDANE}', 'codigoPostalDANE': '${args.codigoPostalDANE}', 'codigoCiudadInterno': '${args.codigoCcodigoPostalDANEiudadInterno}', 'codBarrasRdo': '${args.codBarrasRdo}'`
              let argsUpdCl2 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Facturacion.updateMany'}
              // updDoc.push(argsUpdCl2)

              argsMatch = `'codigoCiudad': '${args.codigoCiudad}'`
              argsSet = `'nombreCiudad': '${args.nombreCiudad}'`
              let argsUpdCl3 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Recurso.updateMany'}

              argsMatch = `'codigoCiudad': '${args.codigoCiudad}'`
              argsSet = `'nombreCiudad': '${args.nombreCiudad}'`
              let argsUpdCl4 = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Usuario.updateMany'}

              updDoc.push(argsUpdCl1)
              updDoc.push(argsUpdCl2)
              updDoc.push(argsUpdCl3)
              updDoc.push(argsUpdCl4)

              // console.log(updDoc)

              updDoc.forEach((elemento, ii) => {
                // console.log(elemento)
                updDocMany.push(elemento)
                updDocMany1.push({docum: updDocMany})
                updDocMany = []
              })
              // updDocMany1.push({docum: updDocMany})

              let numDocCRUD = 0, totDocCRUD = 4, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }
              // console.log(updDocMany1[0])
              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[1]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[2]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              numDocCRUD += 1
              argsCrud[numDocCRUD] = updDocMany1[3]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              // console.log(argsCrud)
              await updColecc(crudColecc, argsCrud, totDocCRUD)
              // FIN ACTUALIZA EN clientes, facturacions, recursos Y usuarios
            }
          }else{
            this.setState({errorAdd: errors})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "tipoAct": "EliminarCiudad",            
            "codigoCiudad": args.codigoCiudad,
            "codigoDpto": args.codigoDpto
          }
          const response = await this.props.deleteDptoUpdCiu({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allDirmayor.refetch()
            this.estadosFalse()
            this.setState({showCiu: true})
          }
        }
      }
    }
  }

  handleZon = async (ev, args)=>{
    if(!args.codigoZona||!args.nombreZona||!args.nombreCiudad||args.nombreCiudad==="Seleccionar..."){
      let sinCampo='XXX'
      this.validarHandle(args.codigoZona, 'codigoZona', '', 'Debe escribir el código',
                        args.nombreZona, 'nombreZona', '', 'Debe escribir la descripción',
                        args.nombreCiudad, 'nombreCiudad', 'Seleccionar...', 'Debe seleccionar la ciudad',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addZon){
//Validar si el codigo o el nombre de la zona ya existe en la ciudad
        var editar = "CrearZona2"
        const errors = [];
        const elemento3 = this.props.allDirmayor.allDirmayor
        elemento3.forEach((elemento, _id) => {
          // if(elemento.ciudades.length>0 && elemento._id===args._id){
          if(elemento.ciudades.length>0 && elemento._id===args._id){
            elemento.ciudades.forEach((elemento1, i) => {
              if(args.codigoCiudad===elemento1.codigoCiudad){
                elemento1.zonas.forEach((elemento2, i) => {
                  if(!elemento2.codigoZona){
                    editar = "CrearZona1"
                    // console.log("NO tiene zonas")
                  }else{
                    if(args.codigoZona===elemento2.codigoZona){
                      errors.push({path: 'codigoZona', message: "El código de la zona ya existe"});
                    }
                    if(args.nombreZona===elemento2.nombreZona){
                      errors.push({path: 'nombreZona', message: "El nombre de la zona ya existe"});
                    }
                  }
                })
              }
            })
          }
        })
//
        if(errors.length===0){
          const fechaHoy = new Date()
          let argsUpd = {}
          argsUpd = {
            "_id": args._id,
            "tipoAct": editar,
            "codigoCiudad": args.codigoCiudad,
            "codigoZona": args.codigoZona,
            "nombreZona": args.nombreZona,
            "fechaCreateZon": fechaHoy,
            "usuarioCreateZon": sessionStorage.getItem('userLogin')
          }
          const response = await this.props.editDptoUpdCiu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var codigoZona = document.getElementById("codigoZona");
            var nombreZona = document.getElementById("nombreZona");

            var dpto = document.getElementById("miLista");
            dpto.options.selectedIndex = 0

            // var zona = document.getElementById("miLista1");
            // zona.options.selectedIndex = 0
            codigoZona.value = ""
            nombreZona.value = ""
            this.setState({argsAdd: {}})
            // this.setState({argsAdd: {}})
            // const errors = [];
            // this.setState({errorAdd: errors})
            this.setState({errorAdd: []})
            this.props.allDirmayor.refetch()
          }
        }else{
          this.setState({errorAdd: errors})
        }
      }else{
        if(this.state.permiteUpdate){
//Validar si el codigo o el nombre de la zona ya existe en la ciudad
          const errors = [];
          const elemento3 = this.props.allDirmayor.allDirmayor
          elemento3.forEach((elemento, _id) => {
            if(elemento.ciudades.length>0 && elemento._id===args._id){
              elemento.ciudades.forEach((elemento1, i) => {
                if(args.codigoCiudad===elemento1.codigoCiudad){
                  elemento1.zonas.forEach((elemento2, i) => {
                    if(elemento2.codigoZona){
                      if(args.nombreZona===elemento2.nombreZona && args.codigoZona!==elemento2.codigoZona){
                        errors.push({path: 'nombreZona', message: "El nombre de la zona ya existe"});
                      }
                    }
                  })
                }
              })
            }
          })
//
          if(errors.length===0){
            const argsUpd = {
              "_id": args._id,
              "tipoAct": "EditarZona",
              "codigoCiudad": args.codigoCiudad,
              "codigoZona": args.codigoZona,
              "nombreZona": args.nombreZona,
            }
            const response = await this.props.editDptoUpdCiu({
              variables: argsUpd
            });
            const {errors, success} = response.data.editDptoUpdCiu;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              this.props.allDirmayor.refetch()
              this.estadosFalse()
              this.setState({showZon: true})

              //ACTUALIZA EN clientes
              let updDoc = [], updDocMany = [], updDocMany1 = []

              let updMatch1 = args.nombreZonaAnt
              let updMatch2 = args.codigoCiudad
              let updSet1 = args.nombreZona
              let argsMatch = `'dirmayor.ciudades.zonas.nombreZona': '${updMatch1}',
                              'dirmayor.ciudades.codigoCiudad': '${updMatch2}'`
              let argsSet = `'dirmayor.ciudades.zonas.nombreZona': '${updSet1}'`

              let argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Cliente.updateMany'}
              updDoc.push(argsUpd)

              updDoc.forEach((elementoDX, ii) => {
                updDocMany.push(elementoDX)
              })
              updDocMany1.push({docum: updDocMany})

              let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }

              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              await updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA EN clientes

              //ACTUALIZA EN facturacions
              updDoc = []
              updDocMany = []
              updDocMany1 = []

              updMatch1 = args.nombreZonaAnt
              updSet1 = args.nombreZona
              argsMatch = `'nombreZona': '${updMatch1}'`
              argsSet = `'nombreZona': '${updSet1}'`

              argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Facturacion.updateMany'}
              updDoc.push(argsUpd)

              updDoc.forEach((elementoDX, ii) => {
                updDocMany.push(elementoDX)
              })
              updDocMany1.push({docum: updDocMany})

              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }

              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              await updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA EN facturacions
            }
          }else{
            this.setState({errorAdd: errors})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "tipoAct": "EliminarZona",
            "codigoCiudad": args.codigoCiudad,
            "codigoZona": args.codigoZona,
            "codigoDpto": args.codigoDpto
          }
          const response = await this.props.deleteDptoUpdCiu({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allDirmayor.refetch()
            this.estadosFalse()
            this.setState({showZon: true})
          }
        }
      }
    }
  }

  handleBarr = async (ev, args)=>{
    // console.log(args)
    if(!args.codigoBarrio||!args.nombreBarrio||!args.nombreZona||args.nombreZona==="Seleccionar..."||
      !args.descrRecursoT||args.descrRecursoT==="Seleccionar..."||
      !args.descrRecursoR||args.descrRecursoR==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoBarrio){
        argsAdd['codigoBarrio'] = "";
        errors.push({path: 'codigoBarrio', message: "Debe escribir el código"});
      }
      if(!args.nombreBarrio){
        argsAdd['nombreBarrio'] = "";
        errors.push({path: 'nombreBarrio', message: "Debe escribir la descripción"});
      }
      if(!args.nombreZona||args.nombreZona==="Seleccionar..."){
        argsAdd['nombreZona'] = "Seleccionar...";
        errors.push({path: 'Zona', message: "Debe seleccionar la zona"});
      }
      if(!args.descrRecursoT||args.descrRecursoT==="Seleccionar..."){
        argsAdd['descrRecursoT'] = "Seleccionar...";
        errors.push({path: 'Area técnica', message: "Debe seleccionar el Area de aprovechamiento - TECNICA"});
      }
      if(!args.descrRecursoR||args.descrRecursoR==="Seleccionar..."){
        argsAdd['descrRecursoR'] = "Seleccionar...";
        errors.push({path: 'Area de recaudo', message: "Debe seleccionar el Area de aprovechamiento - RECAUDO"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addBarr){
//Validar si el codigo o el nombre del barrio ya existe en la ciudad
        var editar = "CrearBarrio2"
        const errors = [];
        const elemento3 = this.props.allDirmayor.allDirmayor

        elemento3.forEach((elemento, _id) => {
          elemento.ciudades.forEach((elemento1, i) => {
            elemento1.zonas.forEach((elemento2, i) => {
              elemento2.barrios.forEach((elemento3, i) => {
                if(elemento3.codigoBarrio){
                  if(args.codigoBarrio===elemento3.codigoBarrio){
                    errors.push({path: 'codigoBarrio', message: "El código del barrio ya existe"});
                  }
                }
              })
            })
          })
        })
        if(errors.length===0){
          elemento3.forEach((elemento, _id) => {
            if(elemento.ciudades.length>0 && elemento._id===args._id){
              elemento.ciudades.forEach((elemento1, i) => {
                if(args.codigoCiudad===elemento1.codigoCiudad){
                  elemento1.zonas.forEach((elemento2, i) => {
                    if(args.codigoZona===elemento2.codigoZona){
                      elemento2.barrios.forEach((elemento3, i) => {
      
                        if(!elemento3.codigoBarrio){
                          editar = "CrearBarrio1"
                          // console.log("NO tiene barrios")
                        }else{
                          if(args.codigoBarrio===elemento3.codigoBarrio){
                            errors.push({path: 'codigoBarrio', message: "El código del barrio ya existe en la ciudad"});
                          }
                          if(args.nombreBarrio===elemento3.nombreBarrio){
                            errors.push({path: 'nombreBarrio', message: "El nombre del barrio ya existe en la ciudad"});
                          }
                        }
                      })
                    }else{
                      elemento2.barrios.forEach((elemento3, i) => {
                        if(elemento3.codigoBarrio){
                          if(args.codigoBarrio===elemento3.codigoBarrio){
                            errors.push({path: 'codigoBarrio', message: "El código del barrio ya existe en la ciudad"});
                          }
                          if(args.nombreBarrio===elemento3.nombreBarrio){
                            errors.push({path: 'nombreBarrio', message: "El nombre del barrio ya existe en la ciudad"});
                          }
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
//
        if(errors.length===0){
          const fechaHoy = new Date()
          const argsUpd = {
            "_id": args._id,
            "tipoAct": editar,
            "codigoCiudad": args.codigoCiudad,
            "codigoZona": args.codigoZona,
            "nombreZona": args.nombreZona,
            "codigoBarrio": args.codigoBarrio,
            "nombreBarrio": args.nombreBarrio,
            "descrRecursoT": args.descrRecursoT,
            "numeroDocumT": args.numeroDocumT,
            "codigoTipoDocT": args.codigoTipoDocT,
            "descrRecursoR": args.descrRecursoR,
            "numeroDocumR": args.numeroDocumR,
            "codigoTipoDocR": args.codigoTipoDocR,
            "fechaCreateBarr": fechaHoy,
            "usuarioCreateBarr": sessionStorage.getItem('userLogin')
          }
          // console.log(argsUpd)
          const response = await this.props.editDptoUpdCiu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            var codigoBarrio = document.getElementById("codigoBarrio");
            var nombreBarrio = document.getElementById("nombreBarrio");

            var dpto = document.getElementById("miLista");
            dpto.options.selectedIndex = 0

            // var barrio = document.getElementById("miLista2");
            // barrio.options.selectedIndex = 0
            var tecnico = document.getElementById("miListaT");
            tecnico.options.selectedIndex = 0
            var recaudo = document.getElementById("miListaR");
            recaudo.options.selectedIndex = 0
            
            codigoBarrio.value = ""
            nombreBarrio.value = ""
            this.setState({argsAdd: {}})
            // this.setState({argsAdd: {}})
            // const errors = [];
            // this.setState({errorAdd: errors})
            this.setState({errorAdd: []})
            this.props.allDirmayor.refetch()
          }
        }else{
          this.setState({errorAdd: errors})
        }
      }else{
        if(this.state.permiteUpdate){
          // console.log(args)

//Validar si el codigo o el nombre de la zona ya existe en la ciudad
          const errors = [];
          const elemento3 = this.props.allDirmayor.allDirmayor
          elemento3.forEach((elemento, _id) => {
            if(elemento.ciudades.length>0 && elemento._id===args._id){
              elemento.ciudades.forEach((elemento1, i) => {
                if(args.codigoCiudad===elemento1.codigoCiudad){
                  elemento1.zonas.forEach((elemento2, i) => {
                      elemento2.barrios.forEach((elemento3, i) => {
                        if(elemento3.codigoBarrio){
                          if(args.nombreBarrio===elemento3.nombreBarrio && args.codigoBarrio!==elemento3.codigoBarrio){
                            errors.push({path: 'nombreBarrio', message: "El nombre del barrio ya existe en la ciudad"});
                          }
                        }
                      })
                  })
                }
              })
            }
          })

          if(errors.length===0){
            const argsUpd = {
              "_id": args._id,
              "tipoAct": "EditarBarrio",
              "codigoCiudad": args.codigoCiudad,
              "codigoZona": args.codigoZona,
              "codigoBarrio": args.codigoBarrio,
              "nombreBarrio": args.nombreBarrio,
              "descrRecursoT": args.descrRecursoT,
              "numeroDocumT": args.numeroDocumT,
              "codigoTipoDocT": args.codigoTipoDocT,
              "descrRecursoR": args.descrRecursoR,
              "numeroDocumR": args.numeroDocumR,
              "codigoTipoDocR": args.codigoTipoDocR,
              }
            const response = await this.props.editDptoUpdCiu({
              variables: argsUpd
            });
            const {errors, success} = response.data.editDptoUpdCiu;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              this.props.allDirmayor.refetch()
              this.estadosFalse()
              this.setState({showBarr: true})

              //ACTUALIZA EN clientes
              let updDoc = [], updDocMany = [], updDocMany1 = []

              let updMatch1 = args.nombreBarrioAnt
              let updMatch2 = args.codigoCiudad
              let updSet1 = args.nombreBarrio
              let updSet2 = args.codigoTipoDocT
              let updSet3 = args.numeroDocumT
              let updSet4 = args.descrRecursoT
              let updSet5 = args.codigoTipoDocR
              let updSet6 = args.numeroDocumR
              let updSet7 = args.descrRecursoR
              let argsMatch = `'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${updMatch1}',
                              'dirmayor.ciudades.codigoCiudad': '${updMatch2}'`
              let argsSet = `'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${updSet1}',
                              'dirmayor.ciudades.zonas.barrios.codigoTipoDocT': '${updSet2}',
                              'dirmayor.ciudades.zonas.barrios.numeroDocumT': '${updSet3}',
                              'dirmayor.ciudades.zonas.barrios.descrRecursoT': '${updSet4}',
                              'dirmayor.ciudades.zonas.barrios.codigoTipoDocR': '${updSet5}',
                              'dirmayor.ciudades.zonas.barrios.numeroDocumR': '${updSet6}',
                              'dirmayor.ciudades.zonas.barrios.descrRecursoR': '${updSet7}'`

              // let argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}, {multi: true}`}
              let argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Cliente.updateMany'}
              updDoc.push(argsUpd)

              updDoc.forEach((elementoDX, ii) => {
                updDocMany.push(elementoDX)
              })
              updDocMany1.push({docum: updDocMany})

              let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }

              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              // console.log(argsCrud)
              await updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA EN clientes
              
              //ACTUALIZA EN facturacions
              updDoc = []
              updDocMany = []
              updDocMany1 = []

              updMatch1 = args.nombreBarrioAnt
              updSet1 = args.nombreBarrio
              argsMatch = `'nombreBarrio': '${updMatch1}'`
              argsSet = `'nombreBarrio': '${updSet1}'`

              argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Facturacion.updateMany'}
              updDoc.push(argsUpd)

              updDoc.forEach((elementoDX, ii) => {
                updDocMany.push(elementoDX)
              })
              updDocMany1.push({docum: updDocMany})

              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }

              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              await updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA EN facturacions
            }
          }else{
            this.setState({errorAdd: errors})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "tipoAct": "EliminarBarrio",
            "codigoCiudad": args.codigoCiudad,
            "codigoZona": args.codigoZona,
            "codigoBarrio": args.codigoBarrio,
            "codigoDpto": args.codigoDpto
          }
          const response = await this.props.deleteDptoUpdCiu({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteDptoUpdCiu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allDirmayor.refetch()
            this.estadosFalse()
            this.setState({showBarr: true})
          }
        }
      }
    }
  }

  handleTiUndMat = async (ev, args)=>{
    if(!args.codigoTiUndMat||!args.descrTiUndMat){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTiUndMat){
        argsAdd['codigoTiUndMat'] = "";
        errors.push({path: 'codigoTiUndMat', message: "Debe escribir el código"});
      }
      if(!args.descrTiUndMat){
        argsAdd['descrTiUndMat'] = "";
        errors.push({path: 'descrTiUndMat', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTiUndMat){
        const response = await this.props.createTiUndMat({
          variables: args
        });
        const {errors, success} = response.data.createTiUndMat;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoTiUndMat = document.getElementById("codigoTiUndMat");
          var descrTiUndMat = document.getElementById("descrTiUndMat");
          codigoTiUndMat.value = ""
          descrTiUndMat.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTiUndMat.refetch()
        }
      }else{
        if(this.state.permiteUpdate){

          const argsUpd = {
            _id: args._id,
            descrTiUndMat: args.descrTiUndMat
          }
          const response = await this.props.editTiUndMat({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTiUndMat;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTiUndMat.refetch()
            this.estadosFalse()
            this.setState({showTiUndMat: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTiUndMat({
            variables: argsDel
          });
          this.props.allTiUndMat.refetch()
          this.estadosFalse()
          this.setState({showTiUndMat: true})
        }
      }
    }
  }

  handleUndMat = async (ev, args)=>{
    if(!args.descrUndMat||!args.descrTiUndMat||args.descrTiUndMat==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrUndMat){
        argsAdd['descrUndMat'] = "";
        errors.push({path: 'descrUndMat', message: "Debe escribir la descripción"});
      }
      if(!args.descrTiUndMat||args.descrTiUndMat==="Seleccionar..."){
        argsAdd['_idTiUndMat'] = "";
        argsAdd['descrTiUndMat'] = "Seleccionar...";
        errors.push({path: 'TiUndMat', message: "Debe seleccionar el tipo de unidad matriz"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addUndMat){
        const response = await this.props.createUndMat({
          variables: args
        });
        const {errors, success} = response.data.createUndMat;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrUndMat = document.getElementById("descrUndMat");
          var tiundmat = document.getElementById("miLista");
          tiundmat.options.selectedIndex = 0
          descrUndMat.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allUndMat.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrUndMat: args.descrUndMat,
            idTiUndMat: args.idTiUndMat,
            codigoTiUndMat: args.codigoTiUndMat,
            descrTiUndMat: args.descrTiUndMat,
          }
          const response = await this.props.editUndMat({
            variables: argsUpd
          });
          const {errors, success} = response.data.editUndMat;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allUndMat.refetch()
            this.estadosFalse()
            this.setState({showUndMat: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteUndMat({
            variables: argsDel
          });

          this.props.allUndMat.refetch()
          this.estadosFalse()
          this.setState({showUndMat: true})
        }
      }
    }
  }

  handleTipoUnd = async (ev, args)=>{
    if(!args.descrTipoUnd){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrTipoUnd){
        argsAdd['descrTipoUnd'] = "";
        errors.push({path: 'descrTipoUnd', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipoUnd){
        const response = await this.props.createTipoUnd({
          variables: args
        });
        const {errors, success} = response.data.createTipoUnd;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrTipoUnd = document.getElementById("descrTipoUnd");
          descrTipoUnd.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTipoUnd.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrTipoUnd: args.descrTipoUnd
          }
          const response = await this.props.editTipoUnd({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoUnd;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoUnd.refetch()
            this.estadosFalse()
            this.setState({showTipoUnd: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTipoUnd({
            variables: argsDel
          });
          this.props.allTipoUnd.refetch()
          this.estadosFalse()
          this.setState({showTipoUnd: true})
        }
      }
    }
  }

  handleTipoVia = async (ev, args)=>{
    // console.log(args)
    if(!args.descrTipoVia){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrTipoVia){
        argsAdd['descrTipoVia'] = "";
        errors.push({path: 'descrTipoVia', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipoVia){
        const response = await this.props.createTipoVia({
          variables: args
        });
        const {errors, success} = response.data.createTipoVia;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrTipoVia = document.getElementById("descrTipoVia");
          descrTipoVia.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTipoVia.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrTipoVia: args.descrTipoVia
          }
          const response = await this.props.editTipoVia({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoVia;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoVia.refetch()
            this.estadosFalse()
            this.setState({showTipoVia: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTipoVia({
            variables: argsDel
          });
          this.props.allTipoVia.refetch()
          this.estadosFalse()
          this.setState({showTipoVia: true})
        }
      }
    }
  }

  handleEstrato = async (ev, args)=>{
    if(!args.descrEstrato){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrEstrato){
        argsAdd['descrEstrato'] = "";
        errors.push({path: 'descrEstrato', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addEstrato){
        const response = await this.props.createEstrato({
          variables: args
        });
        const {errors, success} = response.data.createEstrato;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrEstrato = document.getElementById("descrEstrato");
          descrEstrato.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allEstrato.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrEstrato: args.descrEstrato
          }
          const response = await this.props.editEstrato({
            variables: argsUpd
          });
          const {errors, success} = response.data.editEstrato;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allEstrato.refetch()
            this.estadosFalse()
            this.setState({showEstrato: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteEstrato({
            variables: argsDel
          });
          this.props.allEstrato.refetch()
          this.estadosFalse()
          this.setState({showEstrato: true})
        }
      }
    }
  }

  handleNodo = async (ev, args)=>{
    if(!args.descrNodo){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrNodo){
        argsAdd['descrNodo'] = "";
        errors.push({path: 'descrNodo', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addNodo){
        const response = await this.props.createNodo({
          variables: args
        });
        const {errors, success} = response.data.createNodo;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrNodo = document.getElementById("descrNodo");
          descrNodo.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allNodo.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrNodo: args.descrNodo,
            descrNodoAnt: args.descrNodoAnt
          }
          const response = await this.props.editNodo({
            variables: argsUpd
          });
          const {errors, success} = response.data.editNodo;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allNodo.refetch()
            this.estadosFalse()
            this.setState({showNodo: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrNodo: args.descrNodo
          }
          const response = await this.props.deleteNodo({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteNodo;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allNodo.refetch()
            this.estadosFalse()
            this.setState({showNodo: true})
          }
        }
      }
    }
  }

  handleUndMatTipo = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrTiUndMat'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_idTiUndMat'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTiUndMat'] = miLista.options[miLista.selectedIndex].attributes[0].value
// console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleRecTec = () => {
    var miLista = document.getElementById("miListaT");
    const argsAdd = this.state.argsAdd
    argsAdd['descrRecursoT'] = miLista.options[miLista.selectedIndex].text
    argsAdd['numeroDocumT'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[0].value
    // console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleRecRec = () => {
    var miLista = document.getElementById("miListaR");
    const argsAdd = this.state.argsAdd
    argsAdd['descrRecursoR'] = miLista.options[miLista.selectedIndex].text
    argsAdd['numeroDocumR'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleCiudadDpto = () => {
    // console.log(this.state)
    this.setState({argsAdd: {}})
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    if(this.state.addBarr){
      argsAdd['nombreZona'] = ""
      argsAdd['codigoZona'] = ""
      argsAdd['nombreCiudad'] = ""
      argsAdd['codigoCiudad'] = ""
    }    
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
    // console.log(this.state.argsAdd)
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
    argsAdd['_id'] = this.state.argsAdd._id
    argsAdd['descrDpto'] = this.state.argsAdd.descrDpto
    this.setState({argsAdd});
    // console.log(this.state.argsAdd)
  }

  handleBarrioZona = () => {
    // console.log("entro barriozona")
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreZona'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoZona'] = miLista.options[miLista.selectedIndex].value
    argsAdd['nombreCiudad'] = this.state.argsAdd.nombreCiudad
    argsAdd['codigoCiudad'] = this.state.argsAdd.codigoCiudad
    argsAdd['_id'] = this.state.argsAdd._id
    argsAdd['descrDpto'] = this.state.argsAdd.descrDpto
    this.setState({argsAdd});
    // console.log(this.state.argsAdd)
  }

  idLista = async (ev, idLista)=>{
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showDpto) {
      this.setState({verDpto: true})
    }
    if (this.state.showCiu) {
      this.setState({verCiu: true})
    }
    if (this.state.showZon) {
      this.setState({verZon: true})
    }
    if (this.state.showBarr) {
      this.setState({verBarr: true})
    }
    if (this.state.showTiUndMat) {
      this.setState({verTiUndMat: true})
    }
    if (this.state.showUndMat) {
      this.setState({verUndMat: true})
    }
    if (this.state.showTipoUnd) {
      this.setState({verTipoUnd: true})
    }
    if (this.state.showTipoVia) {
      this.setState({verTipoVia: true})
    }
    if (this.state.showEstrato) {
      this.setState({verEstrato: true})
    }
    if (this.state.showNodo) {
      this.setState({verNodo: true})
    }
  }

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: true,
      permiteDelete: false,
    })
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  render(){
    const {showDir, showDpto, addDpto, verDpto,
          showCiu, addCiu, verCiu,
          showZon, addZon, verZon,
          showBarr, addBarr, verBarr,
          showTiUndMat, addTiUndMat, verTiUndMat,
          showUndMat, addUndMat, verUndMat,
          showTipoUnd, addTipoUnd, verTipoUnd,
          showTipoVia, addTipoVia, verTipoVia,
          showEstrato, addEstrato, verEstrato,
          showNodo, addNodo, verNodo,
          argsAdd, errorAdd, permiteUpdate, permiteDelete, idLista} = this.state;
    // console.log(idLista, verCiu)
    // console.log(this.props.allDirmayor.allDirmayor)
    let lista = []
    let lista1 = []
    if (this.state.showDpto) {
      if(this.props.allDirmayor.allDirmayor){lista = this.props.allDirmayor.allDirmayor}
    }
    if (this.state.showCiu || this.state.addCiu || this.state.verCiu) {
      if(this.props.allDirmayor.allDirmayor){lista = this.props.allDirmayor.allDirmayor}
    }
    if (this.state.showZon || this.state.addZon || this.state.verZon) {
      if(this.props.allDirmayor.allDirmayor){lista = this.props.allDirmayor.allDirmayor}
    }
    if (this.state.showBarr || this.state.addBarr || this.state.verBarr) {
      if(this.props.allDirmayor.allDirmayor){lista = this.props.allDirmayor.allDirmayor}
      // console.log(lista)
      if(this.props.allRecurso.allRecurso){
        lista1 = this.props.allRecurso.allRecurso
        if(this.props.codigoDptoUA!=="Todos..."){
          lista1 = lista1.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA||elemento.codigoDpto==="Todos...")
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          lista1 = lista1.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA||elemento.codigoCiudad==="Todas...")
        }
      }
    }
    if (this.state.showTiUndMat) {
      if(this.props.allTiUndMat.allTiUndMat){lista = this.props.allTiUndMat.allTiUndMat}
    }
    if (this.state.showUndMat) {
      if(this.props.allUndMat.allUndMat){lista = this.props.allUndMat.allUndMat}
    }
    if (this.state.addUndMat || this.state.verUndMat) {
      if(this.props.allTiUndMat.allTiUndMat){lista = this.props.allTiUndMat.allTiUndMat}
    }
    if (this.state.showTipoUnd) {
      if(this.props.allTipoUnd.allTipoUnd){lista = this.props.allTipoUnd.allTipoUnd}
    }
    if (this.state.showTipoVia) {
      if(this.props.allTipoVia.allTipoVia){lista = this.props.allTipoVia.allTipoVia}
    }
    if (this.state.showEstrato) {
      if(this.props.allEstrato.allEstrato){lista = this.props.allEstrato.allEstrato}
    }
    if (this.state.showNodo) {
      if(this.props.allNodo.allNodo){lista = this.props.allNodo.allNodo}
    }
    // console.log(lista)
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showDir && <HomeDir1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
              handleClickSel1={this.showDpto} handleClickSel2={this.showCiu}
              handleClickSel3={this.showZon} handleClickSel4={this.showBarr}
              handleClickSel5={this.showTiUndMat} handleClickSel6={this.showUndMat}
              handleClickSel7={this.showTipoUnd} handleClickSel8={this.showTipoVia}
              handleClickSel9={this.showEstrato} handleClickSel10={this.showNodo}/>}

            {showDpto && <DirDpto1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addDpto && <AddDpto1 styles={this.props.styles} handleClickRegr={this.showDpto}/>}
            {verDpto && <VerDpto1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showDpto} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showCiu && <DirCiu1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addCiu && <AddCiu1 styles={this.props.styles} handleClickRegr={this.showCiu}/>}
            {verCiu && <VerCiu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showCiu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showZon && <DirZon1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addZon && <AddZon1 styles={this.props.styles} handleClickRegr={this.showZon}/>}
            {verZon && <VerZon1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showZon} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showBarr && <DirBarr1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addBarr && <AddBarr1 styles={this.props.styles} handleClickRegr={this.showBarr}/>}
            {verBarr && <VerBarr1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showBarr} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTiUndMat && <DirTum1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addTiUndMat && <AddTum1 styles={this.props.styles} handleClickRegr={this.showTiUndMat}/>}
            {verTiUndMat && <VerTum1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTiUndMat} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showUndMat && <DirUm1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addUndMat && <AddUm1 styles={this.props.styles} handleClickRegr={this.showUndMat}/>}
            {verUndMat && <VerUm1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showUndMat} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTipoUnd && <DirTiUn1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addTipoUnd && <AddTiUn1 styles={this.props.styles} handleClickRegr={this.showTipoUnd}/>}
            {verTipoUnd && <VerTiUn1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTipoUnd} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTipoVia && <DirTiVi1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addTipoVia && <AddTiVi1 styles={this.props.styles} handleClickRegr={this.showTipoVia}/>}
            {verTipoVia && <VerTiVi1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTipoVia} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showEstrato && <DirEstr1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addEstrato && <AddEstr1 styles={this.props.styles} handleClickRegr={this.showEstrato}/>}
            {verEstrato && <VerEstr1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showEstrato} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showNodo && <DirNodo1 styles={this.props.styles} handleClickRegr={this.showDir}/>}
            {addNodo && <AddNodo1 styles={this.props.styles} handleClickRegr={this.showNodo}/>}
            {verNodo && <VerNodo1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showNodo} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showDir && <HomeDir2 styles={this.props.styles}/>}

            {showDpto && <DirDpto2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addDpto} list={lista} handleClickidLista={this.idLista}/>}
            {addDpto && <AddDpto2 styles={this.props.styles} handleSubmit={this.handleDpto} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verDpto && <VerDpto2 styles={this.props.styles} handleSubmit={this.handleDpto} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} list={lista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showCiu && <DirCiu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addCiu} list={lista} handleClickidLista={this.idLista}/>}
            {addCiu && <AddCiu2 styles={this.props.styles} list={lista} handleLista={this.handleCiudadDpto} handleSubmit={this.handleCiu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verCiu && <VerCiu2 styles={this.props.styles} list={lista} handleSubmit={this.handleCiu} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showZon && <DirZon2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addZon} list={lista} handleClickidLista={this.idLista}/>}
            {addZon && <AddZon2 styles={this.props.styles} list={lista} handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad} argsSelDpto={argsAdd} handleSubmit={this.handleZon} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verZon && <VerZon2 styles={this.props.styles} list={lista} handleSubmit={this.handleZon} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showBarr && <DirBarr2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addBarr} list={lista} handleClickidLista={this.idLista}/>}
            {addBarr && <AddBarr2 styles={this.props.styles} list={lista} list1={lista1} handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad} handleLista2={this.handleBarrioZona} handleListaT={this.handleRecTec} handleListaR={this.handleRecRec} argsSelDpto={argsAdd} argsSelCiu={argsAdd} handleSubmit={this.handleBarr} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verBarr && <VerBarr2 styles={this.props.styles} list={lista} list1={lista1} handleSubmit={this.handleBarr} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTiUndMat && <DirTum2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTiUndMat} list={lista} handleClickidLista={this.idLista}/>}
            {addTiUndMat && <AddTum2 styles={this.props.styles} handleSubmit={this.handleTiUndMat} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTiUndMat && <VerTum2 styles={this.props.styles} handleSubmit={this.handleTiUndMat} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showUndMat && <DirUm2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addUndMat} list={lista} handleClickidLista={this.idLista}/>}
            {addUndMat && <AddUm2 styles={this.props.styles} list={lista} handleLista={this.handleUndMatTipo} handleSubmit={this.handleUndMat} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verUndMat && <VerUm2 styles={this.props.styles} list={lista} handleSubmit={this.handleUndMat} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTipoUnd && <DirTiUn2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTipoUnd} list={lista} handleClickidLista={this.idLista}/>}
            {addTipoUnd && <AddTiUn2 styles={this.props.styles} handleSubmit={this.handleTipoUnd} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTipoUnd && <VerTiUn2 styles={this.props.styles} handleSubmit={this.handleTipoUnd} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTipoVia && <DirTiVi2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTipoVia} list={lista} handleClickidLista={this.idLista}/>}
            {addTipoVia && <AddTiVi2 styles={this.props.styles} handleSubmit={this.handleTipoVia} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTipoVia && <VerTiVi2 styles={this.props.styles} handleSubmit={this.handleTipoVia} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showEstrato && <DirEstr2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addEstrato} list={lista} handleClickidLista={this.idLista}/>}
            {addEstrato && <AddEstr2 styles={this.props.styles} handleSubmit={this.handleEstrato} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verEstrato && <VerEstr2 styles={this.props.styles} handleSubmit={this.handleEstrato} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showNodo && <DirNodo2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addNodo} list={lista} handleClickidLista={this.idLista}/>}
            {addNodo && <AddNodo2 styles={this.props.styles} handleSubmit={this.handleNodo} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verNodo && <VerNodo2 styles={this.props.styles} handleSubmit={this.handleNodo} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allUndMat, {name:'allUndMat', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allTiUndMat, {name:'allTiUndMat'}),
  graphql(queries.query.allTipoUnd, {name:'allTipoUnd'}),
  graphql(queries.query.allTipoVia, {name:'allTipoVia'}),
  graphql(queries.query.allEstrato, {name:'allEstrato'}),
  graphql(queries.query.allNodo, {name:'allNodo'}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.createDpto, {name:'createDpto'}),
  graphql(queries.mutation.editDpto, {name:'editDpto'}),
  graphql(queries.mutation.deleteDpto, {name:'deleteDpto'}),

  graphql(queries.mutation.editDptoUpdCiu, {name:'editDptoUpdCiu'}),
  graphql(queries.mutation.deleteDptoUpdCiu, {name:'deleteDptoUpdCiu'}),

  graphql(queries.mutation.updDocumMany, {name:'updDocumMany'}),

  graphql(queries.mutation.createTiUndMat, {name:'createTiUndMat'}),
  graphql(queries.mutation.editTiUndMat, {name:'editTiUndMat'}),
  graphql(queries.mutation.deleteTiUndMat, {name:'deleteTiUndMat'}),

  graphql(queries.mutation.createUndMat, {name:'createUndMat'}),
  graphql(queries.mutation.editUndMat, {name:'editUndMat'}),
  graphql(queries.mutation.deleteUndMat, {name:'deleteUndMat'}),

  graphql(queries.mutation.createTipoUnd, {name:'createTipoUnd'}),
  graphql(queries.mutation.editTipoUnd, {name:'editTipoUnd'}),
  graphql(queries.mutation.deleteTipoUnd, {name:'deleteTipoUnd'}),

  graphql(queries.mutation.createTipoVia, {name:'createTipoVia'}),
  graphql(queries.mutation.editTipoVia, {name:'editTipoVia'}),
  graphql(queries.mutation.deleteTipoVia, {name:'deleteTipoVia'}),

  graphql(queries.mutation.createEstrato, {name:'createEstrato'}),
  graphql(queries.mutation.editEstrato, {name:'editEstrato'}),
  graphql(queries.mutation.deleteEstrato, {name:'deleteEstrato'}),
  
  graphql(queries.mutation.createNodo, {name:'createNodo'}),
  graphql(queries.mutation.editNodo, {name:'editNodo'}),
  graphql(queries.mutation.deleteNodo, {name:'deleteNodo'}),
)(HomeDir)
